import type {
  Order,
  OrderCustomer,
  OrderDetails,
  OrderItem,
  OrderStatus,
} from '..';

export type CreateOrderRequest = {
  shopOrderId?: string;
  posId: string;
  productId: string;
  items: OrderItem[];
  customer: OrderCustomer;
};

export type CreateOrderResponse = {
  orderId: string;
  orderFormUrl: string;
};

export type FindOrdersRequestFilter = {
  /**
   * date format: ISO
   * max period (dateFrom - dateTo) is 60 days
   */
  dateFrom: string;
  dateTo: string;
  orderStatuses?: OrderStatus[];
  merchantIds?: string[];
  pointOfSaleIds?: string[];
};

export type FindOrdersRequestSort = {
  key: Extract<keyof Order, 'orderId' | 'orderStatus' | 'orderTimestampUTC'>;
  /**
   * default: ASC
   */
  order: 'ASC' | 'DESC';
};

export type FindOrdersRequestParams = {
  filter?: FindOrdersRequestFilter;
  sort?: FindOrdersRequestSort;
  /**
   * index of the requested page
   * starts from 0
   */
  page: number;
  /**
   * number of elements per page
   * max is 30
   */
  perPage: number;
};

export type FindOrdersResponse = {
  items: Order[];
  pageInfo: {
    page: number;
    total: number;
    pages: number;
  };
};

export interface OrdersApi {
  createOrder: (order: CreateOrderRequest) => Promise<CreateOrderResponse>;
  getOrders: (params: FindOrdersRequestParams) => Promise<FindOrdersResponse>;
  getOrder: (id: string) => Promise<OrderDetails>;
}

export const ORDERS_API_KEY = 'ordersApi';
